import { createSelector } from 'reselect';
import { RootState } from '../../../rootReducer';
import { populateIsVisibleColumnsFlag } from '../TableOptions/Helpers';
import { whatKeysToSave } from './Helpers';
import { getTurbineColumns } from './Helpers';

const getGrid = (state: RootState) => state.landing.turbineInfos;
const getAllHiddenColumns = (state: RootState) => state.landing.allHiddenColumns;

export const prepareTurbineGridDataSelector = createSelector([getGrid, getAllHiddenColumns], (gridData, allHiddenColumns) => {
  if (!gridData || (gridData && gridData.length === 0)) {
    return {
      columns: [],
      dataSource: []
    };
  }

  let columns = getTurbineColumns();

  const dataSource = gridData.map(x => ({
    ...x,
    key: `${x.site}/${x.inspection}/${x.turbine}`
  }));
  populateIsVisibleColumnsFlag(columns, whatKeysToSave().SAVED_HIDDEN_COLUMNS_KEY);

  return {
    columns,
    dataSource
  };
});
